export default function (entity) {

    entity.remove('fade');
};
